import React, { useEffect, useState } from 'react';
import SectionTitle from '../Common/SectionTitle';

const DigiCloud = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Use process.env.PUBLIC_URL for image paths
  const imagePaths = {
    heroImg: `${process.env.PUBLIC_URL}https://png.pngtree.com/png-clipart/20230927/original/pngtree-download-cloud-computing-concept-3d-rendering-png-image_13145169.png`,
    cloudImg: `${process.env.PUBLIC_URL}https://png.pngtree.com/png-clipart/20230927/original/pngtree-download-cloud-computing-concept-3d-rendering-png-image_13145169.png`,
    clientLogo1: `${process.env.PUBLIC_URL}/assets/img/clients-logo-01.png`,
    clientLogo2: `${process.env.PUBLIC_URL}/assets/img/clients-logo-02.png`,
    clientLogo3: `${process.env.PUBLIC_URL}/assets/img/clients-logo-03.png`,
    clientLogo4: `${process.env.PUBLIC_URL}/assets/img/clients-logo-04.png`,
    heroBgImg: `${process.env.PUBLIC_URL}/assets/img/hero-bg-2.jpg`,
    testimonialsBgImg: `${process.env.PUBLIC_URL}/assets/img/testimonials-bg.jpg`
  };
  
  // Set correct page title and scroll to top when component mounts
  useEffect(() => {
    document.title = "DigiCloud Services | Digisoft";
    window.scrollTo(0, 0);
    
    // Force update header visibility
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');
    
    if (header) {
      header.style.display = 'flex';
      header.style.visibility = 'visible';
      header.style.opacity = '1';
      header.style.position = 'fixed';
    }
    
    if (topBar) {
      topBar.style.display = 'block';
      topBar.style.visibility = 'visible';
      topBar.style.opacity = '1';
    }

    // Check if mobile view
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      document.title = "Digisoft Services";
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const pricingPlans = [
    {
      title: 'Tally on Cloud',
      price: null,
      description: 'Guaranteed speed with 24/7 support that gives an edge over competition',
      popular: false,
      features: [
        { text: 'Manager Server', available: true },
        { text: 'Auto Backup', available: true },
        { text: 'Highly Secure', available: true },
        { text: 'Unlimited Companies', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    },
    {
      title: 'VPS SERVER',
      price: null,
      description: 'Extremely Powerful NVMe Based NXTGEN VPS Servers.',
      popular: true,
      features: [
        { text: '2v CPU', available: true },
        { text: '4GB RAM', available: true },
        { text: '30GB Storage', available: true },
        { text: '100% Uptime', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    },
    {
      title: 'DEDICATED SERVER',
      price: null,
      description: 'Extremely Powerful NVMe Based NXTGEN Dedicated Servers.',
      popular: false,
      features: [
        { text: '4v CPU', available: true },
        { text: '64GB RAM', available: true },
        { text: '500GB Storage', available: true },
        { text: '100% Uptime', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    }
  ];

  const faqs = [
    {
      question: 'What is DigiCloud?',
      answer: 'DigiCloud is a business accounting and financial management software designed to simplify complex accounting processes.'
    },
    {
      question: 'Key Features of DigiCloud?',
      answer: 'Includes accounting, inventory management, invoicing, payroll, financial reporting, and compliance.'
    },
    {
      question: 'Is DigiCloud suitable for small businesses?',
      answer: 'Yes, it is scalable for small, medium, and large businesses.'
    },
    {
      question: 'Can I access DigiCloud remotely?',
      answer: 'Yes, via Tally.NET for seamless remote collaboration.'
    }
  ];

  const keyFeatures = [
    {
      title: 'Skill, Talent, and Availability',
      description: 'Our experts always look forward to innovative technology and offering remarkable services to our customers.'
    },
    {
      title: 'Scalability and Execution',
      description: 'We ensure customer satisfaction with fast and reliable solutions for successful businesses.'
    },
    {
      title: 'Security',
      description: 'We guarantee 99.99% uptime with fully secured services.'
    },
    {
      title: 'Fully Managed Services',
      description: 'Optimize performance with our versatile hosting solutions.'
    },
    {
      title: 'Business Continuity',
      description: 'We focus on regular backups, disaster recovery planning, and resilience.'
    },
    {
      title: '24x7 Support',
      description: 'Your project is handled by professionals available round the clock.'
    }
  ];

  // Hero section background style
  const heroBackgroundStyle = {
    backgroundImage: `url(${imagePaths.heroBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.4,
    margin: 0,
    padding: 0
  };

  // CTA section background style
  const ctaBackgroundStyle = {
    backgroundImage: `url(${imagePaths.testimonialsBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: '40%'
  };

  return (
    <div id="details-cloud" className="digicloud-page p-0">
      {/* Hero Section */}
      <section className="digicloud-hero pt-5 section dark-background position-relative">
        <div 
          style={heroBackgroundStyle}
        ></div>
        <div className="container py-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold mb-4">DigiCloud</h1>
              <p className="lead mb-4">
                At Digisoft, we understand that effective financial management is the foundation of every flourishing company. 
                One of the main pillars of our expertise is DigiCloud, which is more than just accounting software—it empowers 
                businesses to make wise decisions and maintain financial transparency.
              </p>
              <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
            </div>
            <div className="col-lg-6 text-center">
              <img 
                src={imagePaths.heroImg} 
                alt="DigiCloud Service" 
                className="img-fluid" 
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="why-choose py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="Why Choose DigiCloud" 
            description1="Benefits of" 
            description2="DigiCloud" 
          />
          
          <div className="row mt-5">
            <div className="col-lg-6 mb-4 order-1 order-lg-1">
              <p className="lead">
                Having years of experience, we provide you with something more than server speed. 
                We believe that your success is ours. At Hosting Safari, we understand your needs 
                and offer world-class services, including fully managed web hosting, email solutions, 
                top-notch dedicated cloud servers, colocation services, Tally on cloud service, and many more.
              </p>
            </div>
            <div className="col-lg-6 mb-4 order-2 order-lg-2 text-center">
              <img 
                src={imagePaths.cloudImg} 
                alt="Cloud Computing" 
                className="img-fluid" 
                style={{ 
                  maxWidth: isMobile ? '70%' : '90%',
                  height: 'auto',
                  marginTop: isMobile ? '0' : '-228px'
                }}
              />
            </div>
          </div>

          <div className="row mt-4">
            {keyFeatures.map((feature, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="feature-icon mb-3">
                      <i className={`bi bi-${index === 0 ? 'people' : index === 1 ? 'graph-up-arrow' : index === 2 ? 'shield-check' : index === 3 ? 'gear' : index === 4 ? 'arrow-repeat' : 'headset'} fs-2 text-primary`}></i>
                    </div>
                    <h4 className="card-title h5">{feature.title}</h4>
                    <p className="card-text text-muted">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section id="digicloud-pricing" className="pricing py-5 section">
        <SectionTitle 
          title="DigiCloud Pricing" 
          description1="Choose your" 
          description2="Plan" 
        />
        
        <div className="container mt-4">
          <p className="text-center mb-5">
            Distinctively recaptiualize principle-centered core competencies through client-centered core competencies.
          </p>
          <div className="row gy-4">
            {pricingPlans.map((plan, index) => (
              <div key={index} className="col-lg-4" data-aos="zoom-in" data-aos-delay={(index + 1) * 100}>
                <div className={`pricing-item ${plan.popular ? 'featured' : ''}`}>
                  {plan.popular && <p className="popular">Popular</p>}
                  <h3>{plan.title}</h3>
                  <p className="description">{plan.description}</p>
                  {plan.price !== null && <h4><sup>$</sup>{plan.price}<span> / month</span></h4>}
                  <a href="#contact" className="cta-btn">Get Demo</a>
                  <ul>
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className={feature.available ? '' : 'na'}>
                        <i className={`bi bi-${feature.available ? 'check' : 'x'}`}></i> <span>{feature.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trusted By Companies */}
      <section className="trusted-by py-5 section light-background">
        <div className="container py-5">
          <h2 className="text-center mb-5">Trusted by Companies</h2>
          <p className="text-center mb-5">
            Rapidiously morph transparent internal or 'organic' sources whereas resource-sucking e-business. 
            Conveniently innovate compelling internal.
          </p>
          
          <div className="logos-slider">
            <div className="logos-slide">
              <img src={imagePaths.clientLogo1} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo2} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo3} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo4} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo1} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo2} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo3} alt="Client" className="client-logo" />
              <img src={imagePaths.clientLogo4} alt="Client" className="client-logo" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="faqs py-5 section light-background">
        <div className="container py-5">
          <h2 className="text-center fw-bold mb-3">Frequently Asked Queries</h2>
          <p className="text-center lead mb-5">Common questions about DigiCloud.</p>
          
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row g-4">
                {faqs.map((faq, index) => (
                  <div key={index} className="col-md-6" data-aos="fade-up" data-aos-delay={(index * 100)}>
                    <div className="faq-card h-100 p-4 bg-white rounded-3 shadow-sm border-top border-primary border-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="faq-icon me-3">
                          <i className={`bi bi-${index === 0 ? 'info-circle' : index === 1 ? 'gear' : index === 2 ? 'building' : 'laptop'} text-primary fs-3`}></i>
                        </div>
                        <h3 className="h5 fw-bold mb-0">{faq.question}</h3>
                      </div>
                      <div className="faq-answer">
                        <p className="mb-0 text-muted">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <a href="#contact" className="btn btn-outline-primary btn-lg">Have more questions?</a>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta py-5 section dark-background">
        <div 
          style={ctaBackgroundStyle} 
          className="position-absolute top-0 start-0 w-100 h-100"
        ></div>
        <div className="container py-5 text-center">
          <h2 className="mb-4">Ready to get started with DigiCloud?</h2>
          <p className="mb-4 lead">Experience the power of cloud computing with our dedicated solutions.</p>
          <a href="#contact" className="btn btn-primary btn-lg">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default DigiCloud; 